module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p6"
  }, [_vm._v("By M.A. C"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("HURCH")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Trouble Comes in Threes")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Wrapped in Leather")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v("HE")]), _vm._v(" "), _c('span', {
    staticClass: "t10"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v("ODS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Priceless")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Perfect")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Pure")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t12"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("EAP")]), _vm._v(" "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "t12"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("AITH")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Shadows in the Night")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("To Touch the Sky")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("With Julie Lynn Hayes")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v("OONLIT")]), _vm._v(" "), _c('span', {
    staticClass: "t10"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v("KIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Be My Alien")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Be My Human")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("Published by D"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a756e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/003.vue
// module id = 60
// module chunks = 0